import React, {
  useState,
  useCallback,
  useImperativeHandle,
  forwardRef,
} from "react";
import PropTypes from "prop-types";
import { InputText, Label } from "../../../components/Inputs";
import { generateUsername } from "../../Worker/components/Utils";

const UsernameChangeFormContent = forwardRef(
  ({ className, model = {}, onSubmit }, ref) => {
    const [firstname, setFirstname] = useState(model.firstname || "");
    const [lastname, setLastname] = useState(model.lastname || "");
    const [username, setUsername] = useState(model.username || "");
    const [error, setError] = useState({
      firstname: null,
      lastname: null,
      username: null,
    });

    const validate = useCallback(() => {
      const current = { firstname, lastname, username };
      let isValid = true;
      const newError = { ...error };

      Object.keys(current).forEach((key) => {
        if (newError[key] !== undefined && current[key] === "") {
          newError[key] = "";
          isValid = false;
        }
      });

      setError(newError);
      if (!isValid) return null;

      const { id, username: old_username, email, cellNumber } = model;
      return {
        ...current,
        id,
        email,
        cellNumber: cellNumber || "",
        old_username,
      };
    }, [firstname, lastname, username, error, model]);

    const getModel = useCallback(() => validate(), [validate]);

    useImperativeHandle(ref, () => ({ getModel }), [getModel]);

    const submit = useCallback(() => {
      const m = getModel();
      if (!m) return;
      if (onSubmit) onSubmit(m);
    }, [getModel, onSubmit]);

    const onSetName = useCallback(
      (key, value) => {
        if (key === "lastname") {
          setLastname(value);
          setUsername(generateUsername({ lastname: value, firstname }));
          setError((prev) => ({ ...prev, lastname: null }));
        } else if (key === "firstname") {
          setFirstname(value);
          setUsername(generateUsername({ lastname, firstname: value }));
          setError((prev) => ({ ...prev, firstname: null }));
        }
      },
      [firstname, lastname],
    );

    // expose submit optionally for callers that may use it via ref
    useImperativeHandle(ref, () => ({ getModel, submit }), [getModel, submit]);

    return (
      <div className={className}>
        <div className={`${error.lastname && "error-group"}`}>
          <Label htmlFor="lastname">
            {`Nachname`}
            <span>*</span>
          </Label>
          <InputText
            id="lastname"
            className=""
            value={lastname}
            onChange={(event) => onSetName("lastname", event.target.value)}
          />
        </div>
        <div className={`pad-top ${error.firstname && "error-group"}`}>
          <Label htmlFor="firstname">
            {`Vorname`}
            <span>*</span>
          </Label>
          <InputText
            id="firstname"
            autoFocus
            className=""
            value={firstname}
            onChange={(event) => onSetName("firstname", event.target.value)}
          />
        </div>
        <div className={`pad-top ${error.username && "error-group"}`}>
          <Label htmlFor="username">
            {`Mitarbeiterprofil`}
            <span>*</span>
          </Label>
          <InputText
            id="username"
            className=""
            value={username}
            onChange={(event) => setUsername(event.target.value)}
            disabled
          />
        </div>
      </div>
    );
  },
);

UsernameChangeFormContent.propTypes = {
  className: PropTypes.string,
  model: PropTypes.object,
  onSubmit: PropTypes.func,
};

export default UsernameChangeFormContent;
